<template>
  <svg class="_component-icon-next" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" :style="componentStyle">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 3L6 4.5L11.5 10L6 15.5L7.5 17L14.5 10L7.5 3Z" />
  </svg>
</template>
<script>
export default {
  name: 'Sure',
  /**
   * @prop { String } color 颜色
   */
  props: {
    color: {
      type: String,
      default: '#58556D'
    }
  },
  /**
   * @member { Object } componentStyle 组件style
   */
  computed: {
    componentStyle() {
      return {
        fill: this.color
      };
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
